import { render, staticRenderFns } from "./secondaryMenu.vue?vue&type=template&id=268860f2&scoped=true&"
import script from "./secondaryMenu.vue?vue&type=script&lang=js&"
export * from "./secondaryMenu.vue?vue&type=script&lang=js&"
import style0 from "./secondaryMenu.vue?vue&type=style&index=0&id=268860f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268860f2",
  null
  
)

export default component.exports